import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import SkeletonLoader from '../../../components/ui/SkeletonLoader';

const DashboardSuggestions = ({ suggestions, loading }) => {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="bg-slate-900 rounded-2xl p-6 text-white shadow-xl relative overflow-hidden border border-slate-800">
        <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/10 rounded-full -mr-32 -mt-32 blur-3xl" />
        <div className="relative z-10 flex items-center gap-2 mb-6">
          <Icon name="Sparkles" size={18} className="text-emerald-400" />
          <span className="text-sm font-normal tracking-wider text-emerald-400">Finding best for you...</span>
        </div>
        <div className="space-y-3 relative z-10">
          {[1, 2, 3].map(i => (
            <div key={i} className="h-20 bg-white/5 rounded-xl animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div className="bg-slate-900 rounded-2xl p-6 text-white shadow-xl relative overflow-hidden group border border-slate-800">
      <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/5 rounded-full -mr-32 -mt-32 blur-3xl group-hover:bg-emerald-500/10 transition-colors duration-700" />

      <div className="relative z-10">
        <div className="flex items-center gap-2 text-emerald-400 mb-4">
          <Icon name="Sparkles" size={18} className="fill-emerald-400" />
          <span className="text-sm font-normal tracking-wider">Our Recommendations</span>
        </div>

        <div className="space-y-3">
          {suggestions.map((sug, idx) => (
            <div key={idx} className="bg-white/5 border border-white/10 rounded-xl p-4 flex flex-col items-start gap-3 hover:bg-white/10 transition-all group/card">
              <div className="w-full">
                <h3 className="text-[14px] font-normal text-white mb-1 group-hover/card:text-emerald-300 transition-colors">{sug.title}</h3>
                <p className="text-[12px] text-slate-300 leading-relaxed pr-2">{sug.description}</p>
              </div>
              <button
                onClick={() => navigate(sug.action_link)}
                className="w-full bg-emerald-500/20 hover:bg-emerald-500 text-emerald-300 hover:text-white font-normal py-2 px-4 rounded-lg text-[12px] transition-all flex items-center justify-center gap-2 border border-emerald-500/30 hover:border-emerald-500 shadow-sm"
              >
                {sug.action_text} <Icon name="ArrowRight" size={12} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardSuggestions;
